import React from 'react';
import './InnerPagePadding.scss';

export const InnerPagePadding: React.FC = ({ children }) => (
  <div className="inner-page-padding">{children}</div>
);
